export default __webpack_public_path__ + "images/propstream-connect-visual.png";